// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"cbf5e2a3","455":"b1fc3493","977":"b28f896c"}[chunkId] + ".chunk.js";
};